import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import GameEdit from "../../../user/games/GameEdit.tsx";

export const Route = createFileRoute('/_app/profile/games/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <GameEdit />
}
